
export function smoothScrollToElement(
  el: HTMLElement,
  {
    offset = 0,        
    duration = 900,    
    easing = (t: number) => 
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2,
  }: {
    offset?: number;
    duration?: number;
    easing?: (t: number) => number;
  } = {}
) {
  const startY = window.scrollY || window.pageYOffset;
  const targetY = el.getBoundingClientRect().top + startY - offset;
  const diff = targetY - startY;

  // Respeta "reduced motion"
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, targetY);
    return;
  }

  const startTime = performance.now();

  function tick(now: number) {
    const elapsed = now - startTime;
    const t = Math.min(1, elapsed / duration);
    const eased = easing(t);
    window.scrollTo(0, startY + diff * eased);
    if (t < 1) requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);
}
